<template lang="pug">
  fieldset
    .subtitle List Of
    pbc-button(@click='addItem') +
    .field.has-addons
      .control(v-for='item,i in items',:key='i')

        p Item {{i}}
        pbc-button(@click='deleteItem(item)') X
        property-form(:schema='generateItemSchema(item)',:model='item')

</template>

<script>
import PropertyForm from '@ui/organisms/PropertyForm.vue';
import { abstractField } from "vue-form-generator";
export default {
  mixins: [ abstractField ],
  data() {
    return {
    }
  },
  components:{
    PropertyForm
  },
  methods: {
    deleteItem(item) {
      let elementIndex = -1;
      this.value.forEach( (x,i) => {
        if (item === x) {
          elementIndex = i;
        }
      });

      this.value.splice(elementIndex, 1);
    },
    addItem() {
      this.value.push({
        key:'key',
        value:'value'
      })
    },
    generateItemSchema(item) {
      return {
        fields:[
          {type:this.schema.inputType, label:'Item', model:'data', transformData:this.schema.transformData}
        ]
      }
    }
  },
  computed:{
    items() {
      console.log('value', this.value);
      return this.value.map( (data) => {
        return {
          data
        }
        return data;
        return {
         data
        }
      });
    }
  },
  watch:{
    items:{
      deep:true,
      handler(val) {
        console.log('changed', val);
      }
    }
  }
}
</script>
